/** student/endorsement-tags — KEYS. */
export const studentEndorsementTagsKeys = {
  all: () => ['student', 'endorsement-tags'] as const,
};
